var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Collaborator from './Model';
import { observable, action, runInAction } from 'mobx';
import { api } from '../../helpers/Api';
import Stretch from '../Stretches/Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        // @observable data: Collaborator[] = []
        this.operators = [];
        this.loaded = false;
        this.collaborators = [];
        /*
          prestador/es que soy colaborador
         */
        this.readOperator = function (id) {
            if (id) {
                return api.get("collaborators/operator/".concat(id)).then(function (value) {
                    // console.log('collaborators/client/${id} - value: ', value)
                    _this.operator = value;
                    return value;
                });
            }
            else {
                return api.get('collaborators/operator').then(_this.setOperators);
            }
        };
        this.set = function (value) {
            // console.log('set - Collaborators/Store: ', value)
            if (value) {
                _this.collaborators = value.map(function (collaborator) { return new Collaborator(collaborator); });
            }
            _this.loaded = true;
            return _this.collaborators;
        };
        this.setOperators = function (value) {
            // console.log('set - Collaborators/Store: ', value)
            if (value) {
                _this.collaborators = value.map(function (collaborator) { return new Collaborator(collaborator); });
            }
            _this.loaded = true;
            return _this.collaborators;
        };
        this.replace = function (value) {
            if (value)
                _this.collaborators.splice(_this.collaborators.findIndex(function (f) { return f.id === value.id; }), 1, new Collaborator(value));
            _this.loaded = true;
            return _this.collaborators;
        };
        this.setServices = function (value) {
            if (value) {
                _this.services = value.map(function (service) { return new Stretch(service); });
            }
            _this.loaded = true;
            return _this.services;
        };
    }
    default_1.prototype.create = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var newCollaborator_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.post('/collaborators/client', { client_id: data.client_id })];
                    case 1:
                        newCollaborator_1 = _a.sent();
                        runInAction(function () {
                            _this.collaborators.push(newCollaborator_1);
                        });
                        return [2 /*return*/, newCollaborator_1];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.delete = function (id) {
    };
    default_1.prototype.disable = function (id, disabled) {
    };
    default_1.prototype.read = function (id) {
        if (id) {
            return api.get("collaborators/client/".concat(id)).then(function (value) {
                // console.log('collaborators/client/${id} - value: ', value)
                var collaborator = new Collaborator(value);
                return collaborator;
            });
        }
        else {
            return api.get('collaborators/client').then(this.set);
        }
    };
    default_1.prototype.update = function (id, data) {
        return api.put("/collaborators/client/".concat(id), data).then(this.replace);
    };
    default_1.prototype.getCollaborator = function (codeCollaborator) {
        var _this = this;
        return api.get("collaborators/".concat(codeCollaborator)).then(function (value) {
            _this.loaded = true;
            return new Collaborator(value);
        });
    };
    default_1.prototype.applyCommission = function (collaborator_id) {
        return api.post('/collaborators/commission/' + collaborator_id);
    };
    default_1.prototype.getServicesFromOperator = function () {
        return api.get('/collaborators/operator/services').then(this.setServices);
    };
    __decorate([
        observable
    ], default_1.prototype, "operators", void 0);
    __decorate([
        observable
    ], default_1.prototype, "operator", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "collaborator", void 0);
    __decorate([
        observable
    ], default_1.prototype, "services", void 0);
    __decorate([
        observable
    ], default_1.prototype, "collaborators", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "setOperators", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "setServices", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/Store.ts
// module id = 720
// module chunks = 0